import { stylishMetricResult, suffixNumberDisplay } from 'modules/experiments/utils';
import { MIN_SECTION_WIDTH_FOR_TOTALS } from 'modules/experiments/constants';

import {
  AudienceBreakdownTooltipHeader,
  AudienceBreakdownTooltipWrapper,
  TooltipLabel,
  TooltipMetrics,
} from './Styled';
import { AudienceTooltipRow } from './AudienceTooltipRow';

type TooltipVariant = {
  alphabet: string;
  backgroundColor: string;
  borderColor: string;
  variantPercent: number;
  sends: number;
};

type AudienceBreakdownTooltipProps = {
  label: string;
  percent: number;
  total: number;
  hasSendSize: boolean;
  variants: TooltipVariant[];
  isVariantSection: boolean;
};

export const AudienceBreakdownTooltip = ({
  label,
  percent,
  total,
  hasSendSize,
  variants = [],
  isVariantSection,
}: AudienceBreakdownTooltipProps) => {
  return (
    <AudienceBreakdownTooltipWrapper>
      <AudienceBreakdownTooltipHeader>
        <TooltipLabel>{label}</TooltipLabel>
        <TooltipMetrics>
          <div>{stylishMetricResult(percent / 100, 'percentage')}</div>
          {percent < MIN_SECTION_WIDTH_FOR_TOTALS || !hasSendSize ? null : (
            <div>&nbsp;~{suffixNumberDisplay(total)}</div>
          )}
        </TooltipMetrics>
      </AudienceBreakdownTooltipHeader>
      {isVariantSection
        ? variants.map(({ variantPercent, sends, alphabet, backgroundColor, borderColor }, i) => (
            <AudienceTooltipRow
              key={i}
              index={i}
              variantPercent={variantPercent}
              sends={sends}
              alphabet={alphabet}
              backgroundColor={backgroundColor}
              borderColor={borderColor}
              hasSendSize={hasSendSize}
            />
          ))
        : null}
    </AudienceBreakdownTooltipWrapper>
  );
};
